// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadPackPreview-cls1_WKH","cls2":"DownloadPackPreview-cls2_LG1 DownloadPackPreview-cls1_WKH"};